module.exports = __webpack_public_path__ + "img/pen-circle.f81de2ea.svg";